import React from 'react'
import { com } from '@eidu/form'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { CircularProgress, TextField } from '@mui/material'
import dayjs from 'dayjs'
import DraftFieldValue from '../../domain/entity/DraftFieldValue'
import Field = com.eidu.sharedlib.entity.field.Field

const dateFormat = 'YYYY-MM-DD'

export type EntityFormDateFieldProps = {
  field: Field
  fieldValue: DraftFieldValue | undefined
  updateField?: (value: DraftFieldValue) => void
  error: boolean
  loading?: boolean
  disabled?: boolean
}

const EntityFormDateField = ({
  field,
  fieldValue,
  updateField,
  error,
  loading = false,
  disabled = false,
}: EntityFormDateFieldProps) => (
  <LocalizationProvider dateAdapter={AdapterDayjs}>
    <div>
      {loading ? (
        <TextField
          key={`field-${field.id.toString()}`}
          required={field.required}
          label={field.name}
          value={fieldValue?.value ?? ''}
          disabled
          placeholder=" "
          InputLabelProps={{ shrink: true }}
          InputProps={{
            endAdornment: <CircularProgress size={20} />,
          }}
        />
      ) : (
        <DatePicker
          format={dateFormat}
          key={`field-${field.id.toString()}`}
          disabled={disabled || !updateField}
          label={field.required ? `${field.name} *` : field.name}
          value={fieldValue?.value ? dayjs(fieldValue.value) : null}
          onChange={(pickerValue) => {
            if (pickerValue === null) {
              if (updateField) {
                updateField({ fieldId: field.id, type: field.type, value: '' })
              }
            } else if (pickerValue.isValid()) {
              const newValue = pickerValue.format(dateFormat)
              if (updateField) {
                updateField({ fieldId: field.id, type: field.type, value: newValue })
              }
            }
          }}
          slotProps={{
            textField: {
              error,
              sx: {
                '& .MuiOutlinedInput-root': {
                  '& fieldset': {
                    borderColor: error ? 'red' : undefined,
                  },
                },
              },
            },
            field: { clearable: true },
          }}
        />
      )}
    </div>
  </LocalizationProvider>
)

export default EntityFormDateField
